export default __webpack_public_path__ + "static/media/easy-guide-to-chess.a1b2aa23.webp";